import Vue from 'vue'
import Store from '@/store'

const LOGO_COOPERMAIS = 'default'

const getLogo = file =>
  `${process.env.VUE_APP_AWS_URI}/${process.env.VUE_APP_AWS_FOLDER_LOGOTIPO}/${file}`

Vue.filter('generateLogoURI', function (isIndustry) {
  if (isIndustry) return getLogo(Store.getters['industria'].logotipo)
  return getLogo(LOGO_COOPERMAIS)
})
